import { createBrowserHistory } from "history";
import { FRONTEND_URL } from "../config/index";

export const history = createBrowserHistory({ basename: FRONTEND_URL });

// Navigation action creator that mimics react-router-redux's push
export const push = (path) => {
  history.push(path);
  return {
    type: "@@router/LOCATION_CHANGE",
    payload: { location: { pathname: path } },
  };
};

// Simple router middleware that listens for navigation actions
export const routerMiddleware = (history) => (store) => (next) => (action) => {
  // Ensure action is a plain object
  if (!action || typeof action !== "object" || !action.type) {
    console.error("Invalid action dispatched:", action);
    return;
  }

  if (
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload?.location?.pathname
  ) {
    // Navigation is already handled by the push function
  }
  return next(action);
};
